import { createContext } from 'react';
import TenderFree from '.';

export type TenderFreeValue = {
  data?: TenderFree;
  isExpired: boolean;
  loading: boolean;
};
export const TenderFreeContext = createContext<TenderFreeValue>({
  data: undefined,
  isExpired: false,
  loading: false
});
